if (!customElements.get("selected-reviews-slider")) {
  class SelectedReviewsSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector(".blaze-slider");
    }

    connectedCallback() {
      new BlazeSlider(this.slider, {
        all: {
          loop: true,
          enableAutoplay: true,
          stopAutoplayOnInteraction: true,
          autoplayInterval: 10000,
          transitionDuration: 1000,
          slidesToShow: 1,
        },
      });
    }

    disconnectedCallback() {}
  }

  customElements.define("selected-reviews-slider", SelectedReviewsSlider);
}
